import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Mainpage.css';
import Footer from './Footer';
import L from 'leaflet';
import Navbar from './Navbar';
import Donateform from '../dashboard/components/Donateform'

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactGA from "react-ga4";
import ImpactBanner from '../components/ImpactBanner/ImpactBanner';
import EmailSubscriptionPopup from '../components/EmailSubscriptionPopup/EmailSubscriptionPopup';

function Mainpage() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Landing Page' });
    let map = null; // Declare map variable outside of useEffect

    // Function to initialize map

    const initializeMap = () => {
        // Check if map container already exists
        if (map !== null) {
            // Remove existing map instance
            map.remove();
        }

        // Initialize map
        map = L.map('map').setView([0, 25], 3);

        // Tile layer from OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
        }).addTo(map);

    // Country locations and names
    var countries = [
      { 
          name: ("<h4 style='color: green;'>Kenya</h4><p style='color: black;'>At a Glance<br>&#8226; 115,000+ acres impacted <br>&#8226; 850+ individuals employed from underserved communities<br>1. The Great Rift Valley - Kijabe Forest : -1.053487, 36.645037 <br>&#8226; Provides habitat for wildlife, sustainable economic opportunities for local communities <br>2. Northern coast - Lamu County : -2.151584, 40.795936 <br>&#8226; Mangrove and coastal forest habitats</p>"),
          latlng: [-1.053487, 36.645037] 
      },
      { 
          name: ("<h4 style='color: green;'>Madagascar</h4><p style='color: black;'>At a Glance<br>&#8226; 105,000+ acres impacted<br>&#8226; 3,480+ individuals employed in underserved communities<br>1. Coastal - Northwest Madagascar<br>&#8226; Mangrove reforestation<br>&#8226; Over two million mangroves planted per month<br>&#8226; Protected natural reserves & parks<br>2. Ankarafantsika National Park<br>&#8226; Home to eight species of endangered lemurs<br>&#8226; 70% of the 820 species of plants found in the park are endemic to Madagascar</p>"),
          latlng: [-15.360702, 47.222570]
      },
      { 
          name: ("<h4 style='color: green;'>Mozambique</h4><p style='color: black;'>At a Glance<br>&#8226; 282,000+ acres impacted<br> &#8226; 1,255+ individuals employed from underserved communities<br>Coastal - Maputo Bay : -25.921572, 32.681633<br>&#8226; Mangrove restoration and reforestation</p>"),
          latlng: [-25.921572, 32.681633] 
      },
      { 
          name: ("<h4 style='color: green;'>Ethiopia</h4><p style='color: black;'>At a Glance<br>&#8226; 6000+ acres impacted<br>&#8226; 5+ individuals employed from underserved communities<br>Dawuro zone - Omo Valley of Ethiopia<br>&#8226; Riverine forests and highland peaks restoration<br>&#8226; An agroforestry program to promote food security</p>"),
          latlng: [9.1450, 40.4897] 
      },
      { 
          name: ("<h4 style='color: green;'>Indonesia</h4><p style='color: black;'>At a Glance<br>&#8226; 2,360+ hectares<br>&#8226; 5+ individuals<br>employed in underserved geographies<br>&#8226; Coastal - Biak Island : -1.105133, 135.890019</p>"),
          latlng: [-0.7893, 113.9213] 
      },
      { 
          name: ("<h4 style='color: green;'>Haiti</h4><p style='color: black;'>At a Glance<br>1. Coastal - Southern Haiti : 18.232055, -72.294779<br>&#8226; Mangrove reforestation and restoration project<br>2. Inland - Southeast Haiti : 18.901996, -72.040806<br>&#8226; Planting agroforestry species to promote food security</p>"),
          latlng: [18.9712, -72.2852] 
      },
      { 
          name: ("<h4 style='color: green;'>Philippines</h4><p style='color: black;'>At a Glance<br>&#8226; 39,000+ acres impacted<br>&#8226; 85+ individuals employed from underserved communities employed from underserved geographies<br>1. Bukidnon - Kibuwa Site: 8.243720, 125.042223<br>&#8226; Preserving terrestrial forest and montane rainforest on indigenous land<br>2. Misamis Oriental - Canitoan-Pagatpat Site : 8.461966, 124.572649<br>&#8226; Implementing agroforestry techniques to promote food security<br>&#8226; Protecting the forests and communities from logging</p>"),
          latlng: [12.8797, 121.7740] 
      },
      { 
          name: ("<h4 style='color: green;'>Honduras</h4><p style='color: black;'>At a Glance<br>&#8226; 27,000+ acres impacted<br>&#8226; 120+ individuals<br>employed in underserved communities<br>&#8226; La Tigra National Park : 14.202657, -87.123883</p>"),
          latlng: [15.1997, -86.2419] 
      },
      { 
          name: ("<h4 style='color: green;'>Nepal</h4><p style='color: black;'>At a Glance<br>&#8226; 16,000+ acres impacted<br>&#8226; 190+ individuals employed from underserved communities<br>1. Western Himalayan Mountains – Nawalparasi : 27.644977, 83.864543<br>&#8226; New trees in deforested areas to anchor the soil and protect the villages from environmental disasters<br>2. SE Grasslands - Jhapa : 26.430887, 87.742759<br>&#8226; Restore previously forested land in the region<br>3. Chitwan National Park : 27.533246, 84.452155<br>&#8226; Tropical and subtropical forests in Nepal's first national park</p>"),
          latlng: [28.3949, 84.1240] 
      },
    ];

        // Check if countries array is not empty
        if (countries.length > 0) {
            // Add pins to the map
            countries.forEach(country => {
                const marker = L.marker(country.latlng).addTo(map);
                marker.bindPopup(`<b>${country.name}</b>`).openPopup();
            });

            // Calculate bounds only if countries array is not empty
            const bounds = new L.LatLngBounds();
            countries.forEach(country => {
                bounds.extend(country.latlng);
            });

            // Check if bounds are valid
            if (!bounds.isValid()) {
                console.error('Bounds are not valid.');
                return;
            }

            // Center the map on the average coordinates of the countries
            map.fitBounds(bounds);
        } else {
            console.warn('Countries array is empty.');
        }
    };

    // Call the initializeMap function when component mounts
    initializeMap();
    
    // Cleanup function to remove map instance when component unmounts
    return () => {
        if (map !== null) {
            map.remove();
        }
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <div>
      <Navbar />
      <EmailSubscriptionPopup />
      
      {/* Carousel Start */}
      <div style={{padding: '5%'}} className="container-fluid p-0 wow fadeIn" data-wow-delay="0.1s">
        <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img style={{width: '100%'}} src="/img/img/B5.png" alt="Image" />
              <div className="carousel-caption">
                <div className="cc container-fluid">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-lg-12 text-center">
                      <div className="text-overlay">
                        <h1 style={{marginTop: '2%'}} className="display-1 c-heading mb-5 animated slideInDown headingblack">Plant a Forest </h1>
                        <p style={{marginTop: '-3%', fontSize: '18px'}}>It starts with your donation and
                          reforestation begins one tree at a time with habitat restoration.</p>
                        <a className="btn btn-primary py-sm-3 px-sm-4" href="#donation-section" style={{marginBottom: '3%'}}>Donate</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <img style={{width: '100%'}} src="/img/img/B6.png" alt="Image" />
              <div className="carousel-caption">
                <div className="cc container-fluid">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-lg-12 text-center">
                      <div className="text-overlay">
                        <h1 style={{marginTop: '2%'}} className="display-1 c-heading mb-5 animated slideInDown headingblack">Build Community</h1>
                        <p style={{marginTop: '-3%', fontSize: '18px'}}>With your support, we support local
                          teams to rebuild oxygen-producing ecosystems that bring health and wellness.
                        </p>
                        <a className="btn btn-primary py-sm-3 px-sm-4" href="#donation-section" style={{marginBottom: '3%'}}>Donate</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <img className="w-100" src="/img/img/Madagascar_Mangroves.png" alt="Image" />
              <div className="carousel-caption">
                <div className="cc container-fluid">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-lg-12 text-center">
                      <div className="text-overlay">
                        <h1 style={{marginTop: '2%'}} className="display-1 c-heading mb-5 animated slideInDown headingblack">Transform Lives </h1>
                        <p style={{marginTop: '-3%', fontSize: '18px'}}>Your help fosters community around
                          the
                          world with a holistic approach to stopping deforestation and building
                          sustainable biodiversity.</p>
                        <a className="btn btn-primary py-sm-3 px-sm-4" href="#donation-section" style={{marginBottom: '3%'}}>Donate</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      {/* Carousel End */}



      {/* Top Feature Start */}
      <div className="container-fluid top-feature py-5 pt-lg-0">
        <div className="container py-5 pt-lg-0">
          <div className="row gx-0">
            <div className="col-lg-4 wow fadeIn" data-wow-delay="0.1s">
              <div className="bg-white shadow d-flex align-items-center h-100 px-5" style={{minHeight: '160px'}}>
                <div className="d-flex">
                  <div className="flex-shrink-0 btn-lg-square rounded-circle bg-light">
                    <i className="far fa-comment-alt text-primary" />
                  </div>
                  <div className="ps-3">
                    <h4 style={{color: '#333333'}}>Plant Your First Tree <span style={{color: 'green'}}>With
                        Us</span> </h4>
                    <span style={{fontSize: '13px'}}>Your donation builds local community, and advance
                      long-term sustainability of our
                      planet.</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 wow fadeIn" data-wow-delay="0.5s">
              <div className="bg-white shadow d-flex align-items-center h-100 px-5" style={{minHeight: '160px'}}>
                <div className="d-flex">
                  <div className="flex-shrink-0 btn-lg-square rounded-circle bg-light">
                    <i className="far fa-comment-alt text-primary" />
                  </div>
                  <div className="ps-3">
                    <h4 style={{color: '#333333'}}>Prevent Climate <span style={{color: 'green'}}>Change</span>
                    </h4>
                    <span style={{fontSize: '13px'}}>Global warming and climate change need oxygen-producing
                      vegetation, with mangroves
                      being super-producers that transform CO2 into healthy oxygen. </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 wow fadeIn" data-wow-delay="0.3s">
              <div className="bg-white shadow d-flex align-items-center h-100 px-5" style={{minHeight: '160px'}}>
                <div className="d-flex">
                  <div className="flex-shrink-0 btn-lg-square rounded-circle bg-light">
                    <i className="far fa-comment-alt text-primary" />
                  </div>
                  <div className="ps-3">
                    <h4 style={{color: '#333333'}}>Saving the World Can <span style={{color: 'green'}}>Start
                        Here</span> </h4>
                    <span style={{fontSize: '13px'}}>Help bring clean air to this planet with high-oxygen
                      output and sustainable
                      mangrove forests. </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Top Feature End */}
      {/* About Start */}
      <div className="container-xxl py-5 about customabout">
        <div className="container">
          <div className="row g-5 align-items-center"> {/* Updated this line */}
            <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <img className="img-fluid rounded" data-wow-delay="0.1s" src="/img/img/about3.jpg" height="3000px" />
            </div>
            <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <h1 className="m-0" style={{color: '#333333'}}>Blue Planet<span style={{color: 'green'}}> Ecosystem</span></h1>
              <p className="mb-4" style={{fontSize: '22px', color: 'gray'}}>Our mission is simple yet powerful. We join the global
                efforts to combat deforestation and climate change restoring habitats in key areas around the
                world with <Link to='/site/about' style={{textDecoration: 'underline', fontWeight: 'bold'}}>mangroves</Link>. We believe in the
                profound impact…</p>
              {/* <a className="btn btn-primary py-3 px-4" href="http://planetecosystem.com/about.html">Learn More</Learn Morea> */}
              <Link className="btn btn-primary py-3 px-4" to="/site/about">Learn More</Link>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
      <div className='my-5'>
        <ImpactBanner/>
      </div>
      {/* Features Start */}
      <div style={{marginLeft: '3%', marginTop: '-5%'}} className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <h1 className="display-5 mb-4" style={{marginBottom: 0}}><b>With your help,
                  We:</b></h1>
            </div>
            <div style={{marginTop: '-15px'}} className="container">
              <div className="row">
                <div className="col-md-3" id="project1">
                  {/* Your card content goes here */}
                  <div className="card green-gradient">
                    <div className="card-body">
                      Empower Communities
                    </div>
                  </div>
                </div>
                <div className="col-md-3" id="project1">
                  {/* Your card content goes here */}
                  <div className="card blue-gradient">
                    <div className="card-body">
                      Transform Lives
                    </div>
                  </div>
                </div>
                <div className="col-md-3" id="project1">
                  {/* Your card content goes here */}
                  <div className="card green-gradient">
                    <div className="card-body">
                      Plant Mangroves
                    </div>
                  </div>
                </div>
                <div className="col-md-3" id="project1">
                  {/* Your card content goes here */}
                  <div className="card blue-gradient">
                    <div className="card-body">
                      Reforest Landscapes
                    </div>
                  </div>
                </div>
                <div className="col-md-3" id="project1">
                  {/* Your card content goes here */}
                  <div className="card green-gradient">
                    <div className="card-body">
                      Rejuvenate Habitats
                    </div>
                  </div>
                </div>
                <div className="col-md-3" id="project1">
                  {/* Your card content goes here */}
                  <div className="card blue-gradient">
                    <div className="card-body">
                      Reduce CO2 Emissions
                    </div>
                  </div>
                </div>
                <div className="col-md-3" id="project1">
                  {/* Your card content goes here */}
                  <div className="card green-gradient">
                    <div className="card-body">
                      Produce More Oxygen
                    </div>
                  </div>
                </div>
                <div className="col-md-3" id="project1">
                  {/* Your card content goes here */}
                  <div className="card blue-gradient">
                    <div className="card-body">
                      Save our planet
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Features End */}
      {/* Service Start */}
      <div style={{marginTop: '-5%'}} className="container-xxl py-5">
        <div className="container">
          <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
            <p className="fs-5 fw-bold text-primary">Join us to combat climate change with a variety of green
              initiatives and programs</p>
            <h1 className="display-5 mb-5" style={{color: '#333333'}}>Programs To Join Our <span style={{color: 'green'}}>
                Collective Cause</span></h1>
          </div>
          <div className="row g-4">
            <div className="col-md-3 wow fadeInUp" data-wow-delay="0.1s">
              <Link  to="/site/individual" className="service-item rounded d-flex h-100 details-button" id='parentDiv'>
                <div className="service-img rounded">
                  <img className="img-fluid" src="/img/img/service-1.jpg" alt="" />
                </div>
                <div className="service-text rounded p-5">
                  <div className="btn-square rounded-circle mx-auto mb-3">
                    <img className="img-fluid" src="/img/img/icon-3.png" alt="Icon" />
                  </div>
                  <h4 className="mb-3">Individuals</h4>
                  <h5>Sustainably</h5>
                  <p className="mb-4">Save Earth Reduce waste, conserve energy, plant trees, and embrace
                    sustainable choices for a greener tomorrow.</p>
                  {/* <a className="btn btn-sm" href="http://planetecosystem.com/individual.html"><i className="fa fa-plus text-primary me-2" />Learn
                    More</a> */}
                    <Link className="btn btn-sm" to="/site/individual"><i className="fa fa-plus text-primary me-2" id='div1' /><div id='div2'>Learn More</div></Link>
                </div>
              </Link>
            </div>
            <div className="col-md-3 wow fadeInUp" data-wow-delay="0.3s">
              <Link  to="/site/corporate" className="service-item rounded d-flex h-100 details-button">
                <div className="service-img rounded">
                  <img className="img-fluid" src="/img/img/corporate.jpg" alt="" />
                </div>
                <div className="service-text rounded p-5">
                  <div className="btn-square rounded-circle mx-auto mb-3">
                    <img className="img-fluid" src="/img/img/icon-6.png" alt="Icon" />
                  </div>
                  <h4 className="mb-3">Corporate Partners</h4>
                  <h5>Responsibility</h5>
                  <p className="mb-4">Unite for a sustainable future: Partner with us and your employees to
                    protect and preserve our world.</p>
                  <a className="btn btn-sm"><i className="fa fa-plus text-primary me-2"  id='div1' /><div id='div2'>Learn More</div></a>
                </div>
              </Link>
            </div>
            <div className="col-md-3 wow fadeInUp" data-wow-delay="0.5s">
              <Link to="/site/education" className="service-item rounded d-flex h-100 details-button">
                <div className="service-img rounded">
                  <img className="img-fluid" src="/img/img/service-3.jpg" alt="" />
                </div>
                <div className="service-text rounded p-5">
                  <div className="btn-square rounded-circle mx-auto mb-3">
                    <img className="img-fluid" src="/img/img/icon-5.png" alt="Icon" />
                  </div>
                  <h4 className="mb-3">Educational Institutions</h4>
                  <h5>Institute</h5>
                  <p className="mb-4">Collaborate for a sustainable future: Partner with us to integrate
                    eco-friendly solutions and foster green practices.</p>
                  <a className="btn btn-sm"><i className="fa fa-plus text-primary me-2" id='div1'  /><div id='div2'>Learn More</div></a>
                </div>
              </Link>
            </div>
            <div className="col-md-3 wow fadeInUp" data-wow-delay="0.5s">
              <Link  to="/site/foundation" className="service-item rounded d-flex h-100 details-button">
                <div className="service-img rounded">
                  <img className="img-fluid" src="/img/img/service-6.jpg" alt="" />
                </div>
                <div className="service-text rounded p-5">
                  <div className="btn-square rounded-circle mx-auto mb-3">
                    <img className="img-fluid" src="/img/img/icon-2.png" alt="Icon" />
                  </div>
                  <h4 className="mb-3">Foundations and Trusts</h4>
                  <h5>Trusted</h5>
                  <p>Invest green, save green: Explore eco-friendly investments for tax benefits while
                    contributing to a healthier planet.</p>
                  <a className="btn btn-sm"><i className="fa fa-plus text-primary me-2"  id='div1' /><div id='div2'>Learn More</div></a>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Service End */}
      {/* Map */}
      <h1 style={{color: 'green', textAlign: 'center', marginTop: '1%', marginBottom: '2%'}}>Our Project Locations</h1>
      <div id="map" style={{height: '350px'}} />
      {/* Map End */}
      {/* donation */}
      <div id="donation-section">
        <div id="container" className="container d-flex flex-row align-items-start leftrightcontainer">
          <div id="left-side" className="col-lg-6">
            <img className="img-fluid" src="/img/img/payment2.png" alt="Image" style={{height: '677px'}} />
            <div id="text-overlay" style={{textAlign: 'left', width: '100%', padding: '20px'}}>
              <p style={{color: 'whitesmoke', fontWeight: 'bold'}}>Help us</p>
              <h3 style={{color: 'whitesmoke'}}>Support Our Environment</h3>
              <ul style={{color: 'whitesmoke', listStyle: 'inside', fontSize: '14px', marginLeft: '-30px'}}>
                <li>$1 Plants a tree</li>
                <li>$25 Ensure it matures</li>
                <li>$100 Support a local community in eco-friendly practices</li>
                <li>$500 To restore a habitat</li>
              </ul>
            </div>
          </div>
          <Donateform />
        </div>
      </div>
      {/* donation End */}
      {/* Quote End */}
      {/* Testimonial Start */}
      <div style={{marginTop: '-5%'}}  id="testimonial"className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-5 wow fadeInUp" data-wow-delay="0.1s">
              <p className="fs-5 fw-bold text-primary">Testimonial</p>
              <h1 style={{color: '#333333'}} className="display-5 mb-5">How Your Generosity Transforms Communities</h1>
              <p className="mb-4" style={{fontSize: '25px'}}>
                "Our clients rave about our exceptional service, praising us for our dedication, expertise, and
                transformative impact on their spaces. See why our reputation speaks for itself in the glowing
                testimonials from satisfied customers."</p>
              {/* <a className="btn btn-primary py-3 px-4" href="/testimonials">See More</a> */}
            </div>
            {/* <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="owl-carousel">
                <div className="testimonial-item">
                  <img className="img-fluid rounded mb-3" width='150px'src="/img/img/nima.png" alt="" />
                  <h4>Nima from Nepal</h4>
                  <p style={{fontSize: '16px'}}>
                    During the COVID-19 pandemic, Nima Dolma Lama lost her hotel
                    business and found herself not knowing how she would survive.
                    All she had left was her family’s small farm, which did not
                    yield a sufficient amount of crops year-round, to support her
                    husband, two sons, two daughters-in-law, grandson, and
                    herself. She faced an uphill battle with no formal education
                    and due to the gender inequality prevalent in Nepal. Due to
                    the fallout and lockdowns due to the pandemic, there were very
                    limited employment opportunities available for Nima. However,
                    this did not stop her. She continued to face these obstacles
                    head-on, leading her to connect with our Nepalese partners.
                    Now, Nema has a full-time position in a nursery. With the
                    consistent income she earns, she can afford her family’s daily
                    household expenses. With your suport, Nima can provide for her
                    family, save for the future, and planting trees to save our
                    planet. “I am grateful to make a living restoring the
                    environment, “ says Nima. “I see our reforestation work in
                    Nepal improving the livelihoods in my community.”
                  </p>
                  <h4>Nima Dolma Lama</h4>
                  <span>Story from Nepal</span>
                </div>
                <div className="testimonial-item">
                  <img className="img-fluid rounded mb-3" src="/img/img/george.png" alt="" />
                  <h4>George from Kenya</h4>
                  <p style={{fontSize: '16px'}}>
                    Through our agroforestry program, the teams we support grow an
                    assortment of trees and crops that, in turn, produce direct
                    economic benefits, such as food and medicine, in addition to
                    environmental benefits. In Kenya, this program would not be
                    possible without George Were. Before joining the Kenya team,
                    George was teaching his community how to farm and support
                    their forests. Now as a local leader in agroforestry, George
                    identifies indigenous species to plant, and works with local
                    farmers to provide agricultural training. He enrolls farmers
                    in a vegetable program, in which we grow vegetable seedlings
                    at the nursery and distribute them to farmers to harvest on
                    their land. Without your help, we could not empower people
                    like George to help improve local communities’ livelihoods
                    while restoring degraded land.
                  </p>
                  <h4>George</h4>
                  <span>Story from Bloomsville</span>
                </div>
                <div className="testimonial-item">
                  <img className="img-fluid rounded mb-3" src="/img/img/vays.png" alt="" />
                  <h4>Vayys from Madagascar</h4>
                  <p style={{fontSize: '16px'}}>
                    With limited income, Maman’i Taba (Vavy) had to choose between
                    sending her four children to school or feeding her extended
                    family of ten. She was selling produce at the local market,
                    but the money she earned was not enough to provide for her
                    family’s needs. She felt the pressure of providing for ten
                    people and knew something needed to change. Amid her struggle,
                    Vavy was introduced to our Madagascar team and hired as a
                    Planter, where she selects and collects seeds. Since joining
                    our Madagascar team, Vavy’s children are back in school, she
                    is saving for a new home big enough to accommodate her family,
                    and she can see the environment health around her improving
                    due to your support and her hard work. When you partner with
                    Blue Planet, you not only help the planet but cultivate
                    healthy communities. Help us in Madagascar and around the
                    world, to make more stories such as Vavy’s a reality.
                  </p>
                  <h4>Vayys</h4>
                  <span>Story from Madagascar</span>
                </div>
              </div>
            </div> */}
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <Slider {...settings}>
              <div className="testimonial-item">
                  <img className="img-fluid rounded mb-3" width='150px'src="/img/img/nima.png" alt="" />
                  <h4>Nima from Nepal</h4>
                  <p style={{fontSize: '16px'}}>
                    During the COVID-19 pandemic, Nima Dolma Lama lost her hotel
                    business and found herself not knowing how she would survive.
                    All she had left was her family’s small farm, which did not
                    yield a sufficient amount of crops year-round, to support her
                    husband, two sons, two daughters-in-law, grandson, and
                    herself. She faced an uphill battle with no formal education
                    and due to the gender inequality prevalent in Nepal. Due to
                    the fallout and lockdowns due to the pandemic, there were very
                    limited employment opportunities available for Nima. However,
                    this did not stop her. She continued to face these obstacles
                    head-on, leading her to connect with our Nepalese partners.
                    Now, Nema has a full-time position in a nursery. With the
                    consistent income she earns, she can afford her family’s daily
                    household expenses. With your suport, Nima can provide for her
                    family, save for the future, and planting trees to save our
                    planet. “I am grateful to make a living restoring the
                    environment, “ says Nima. “I see our reforestation work in
                    Nepal improving the livelihoods in my community.”
                  </p>
                  <h4>Nima Dolma Lama</h4>
                  <span>Story from Nepal</span>
                </div>
                <div className="testimonial-item">
                  <img className="img-fluid rounded mb-3" style={{maxWidth:'200px'}} src="/img/img/george.png" alt="" />
                  <h4>George from Kenya</h4>
                  <p style={{fontSize: '16px'}}>
                    Through our agroforestry program, the teams we support grow an
                    assortment of trees and crops that, in turn, produce direct
                    economic benefits, such as food and medicine, in addition to
                    environmental benefits. In Kenya, this program would not be
                    possible without George Were. Before joining the Kenya team,
                    George was teaching his community how to farm and support
                    their forests. Now as a local leader in agroforestry, George
                    identifies indigenous species to plant, and works with local
                    farmers to provide agricultural training. He enrolls farmers
                    in a vegetable program, in which we grow vegetable seedlings
                    at the nursery and distribute them to farmers to harvest on
                    their land. Without your help, we could not empower people
                    like George to help improve local communities’ livelihoods
                    while restoring degraded land.
                  </p>
                  <h4>George</h4>
                  <span>Story from Bloomsville</span>
                </div>
                <div className="testimonial-item">
                  <img className="img-fluid rounded mb-3" style={{maxWidth:'200px'}} src="/img/img/vays.png" alt="" />
                  <h4>Vayys from Madagascar</h4>
                  <p style={{fontSize: '16px'}}>
                    With limited income, Maman’i Taba (Vavy) had to choose between
                    sending her four children to school or feeding her extended
                    family of ten. She was selling produce at the local market,
                    but the money she earned was not enough to provide for her
                    family’s needs. She felt the pressure of providing for ten
                    people and knew something needed to change. Amid her struggle,
                    Vavy was introduced to our Madagascar team and hired as a
                    Planter, where she selects and collects seeds. Since joining
                    our Madagascar team, Vavy’s children are back in school, she
                    is saving for a new home big enough to accommodate her family,
                    and she can see the environment health around her improving
                    due to your support and her hard work. When you partner with
                    Blue Planet, you not only help the planet but cultivate
                    healthy communities. Help us in Madagascar and around the
                    world, to make more stories such as Vavy’s a reality.
                  </p>
                  <h4>Vayys</h4>
                  <span>Story from Madagascar</span>
                </div>
              </Slider>
  </div>
          </div>
        </div>
      </div>
      {/* Testimonial End */}
      <Footer />
      {/* Back to Top */}
      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up" /></a>
    </div>
  );
}

export default Mainpage;